// Mapping de codigos de erro do AWS Cognito -> mensagens PT-BR amigaveis.
// Centralizado aqui pra ser reusado em login, signup, forgot-password e
// qualquer outra tela que dispare Auth.* do amplify.
//
// Lista baseada em codigos comuns do CognitoIdentityServiceProvider:
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/CommonErrors.html

const COGNITO_ERROR_MESSAGES = {
  // Auth.signIn
  UserNotFoundException: 'Usuário não encontrado',
  NotAuthorizedException: 'Senha incorreta',
  InvalidParameterException: 'Usuário ou senha inválidos',
  PasswordResetRequiredException:
    'É necessário redefinir sua senha. Use "Esqueci minha senha".',
  UserNotConfirmedException:
    'Conta ainda não confirmada. Verifique seu e-mail.',
  TooManyRequestsException:
    'Muitas tentativas. Aguarde alguns segundos.',
  TooManyFailedAttemptsException:
    'Muitas tentativas falhadas. Conta temporariamente bloqueada.',
  // Auth.signUp / Auth.confirmSignUp
  UsernameExistsException: 'Este usuário já está cadastrado.',
  CodeMismatchException: 'Código incorreto.',
  ExpiredCodeException: 'Código expirado. Solicite um novo.',
  InvalidPasswordException:
    'Senha não atende aos requisitos mínimos.',
  // Genericos
  LimitExceededException:
    'Limite de tentativas excedido. Tente novamente mais tarde.',
  NetworkError: 'Falha de conexão. Verifique sua internet.',
};

// Retorna mensagem mapeada ou fallback generico. Aceita codigo (string)
// OU o objeto error completo do amplify (tem .code).
export const cognitoErrorMessage = (codeOrError) => {
  const code =
    (codeOrError && typeof codeOrError === 'object' && codeOrError.code) ||
    codeOrError;
  if (!code) return 'Ocorreu um erro...';
  return COGNITO_ERROR_MESSAGES[code] || 'Ocorreu um erro...';
};
